import React from 'react'
import Icon from 'components/Icon'

export const Full = ({ children }) => (
  <div className="w-full h-full flex items-center justify-center text-xl text-gray-600">
    { children || (
      <Icon icon={['fal', 'spinner-third']} className="animate-spin" />
    ) }
  </div>
)

export const Flex = ({ children }) => (
  <div className="grow flex justify-center items-center text-xl text-gray-600">
    { children || (
      <Icon icon={['fal', 'spinner-third']} className="animate-spin" />
    ) }
  </div>
)
